import InventoryFilter from "./InventoryFilter.presenter";
export default InventoryFilter;
